import { render, staticRenderFns } from "./Exercice.vue?vue&type=template&id=19ea8cbd&scoped=true&"
import script from "./Exercice.vue?vue&type=script&lang=js&"
export * from "./Exercice.vue?vue&type=script&lang=js&"
import style0 from "./Exercice.vue?vue&type=style&index=0&id=19ea8cbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ea8cbd",
  null
  
)

export default component.exports